import React from "react";
import { useQuery } from "react-query";
import { getScorecardDispute } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useScorecardDispute = () => {
  return useQuery("GetScorecardDispute", getScorecardDispute, {
    refetchOnWindowFocus: false,
  });
};

export default useScorecardDispute;
